import { createAction, props } from '@ngrx/store';
import { DataFeed, DataFeedRequest } from '../../../modules/data-feeds/interfaces';

// load data feeds
export const LOAD_DATA_FEEDS = '[Data Feeds] Load Data Feeds';
export const LOAD_DATA_FEEDS_SUCCESS = '[Data Feeds] Load Data Feeds Success';
export const LOAD_DATA_FEEDS_FAIL = '[Data Feeds] Load Data Feeds Fail';

export const LoadDataFeeds = createAction(LOAD_DATA_FEEDS, props<{ payload: DataFeedRequest[] }>());

export const LoadDataFeedsSuccess = createAction(LOAD_DATA_FEEDS_SUCCESS, props<{ payload: DataFeed[] }>());

export const LoadDataFeedsFail = createAction(LOAD_DATA_FEEDS_FAIL, props<{ payload: Error }>());

// refresh data feeds
export const REFRESH_DATA_FEEDS = '[Data Feeds] Refresh Data Feeds';
export const REFRESH_DATA_FEEDS_SUCCESS = '[Data Feeds] Refresh Data Feeds Success';
export const REFRESH_DATA_FEEDS_FAIL = '[Data Feeds] Refresh Data Feeds Fail';

export const RefreshDataFeeds = createAction(REFRESH_DATA_FEEDS);

export const RefreshDataFeedsSuccess = createAction(REFRESH_DATA_FEEDS_SUCCESS, props<{ payload: DataFeed[] }>());

export const RefreshDataFeedsFail = createAction(REFRESH_DATA_FEEDS_FAIL, props<{ payload: Error }>());

// remove data feed
export const REMOVE_DATA_FEED = '[Data Feeds] Remove Data Feed';

export const RemoveDataFeed = createAction(REMOVE_DATA_FEED, props<{ payload: string }>());

// select vehicle feeds
export const SLECT_VEHICLE_FEEDS = '[Data Feeds] Select Vehicle Feeds';

export const SelectVehcileFeeds = createAction(SLECT_VEHICLE_FEEDS, props<{ payload: string[] }>());

// select station feeds
export const SELECT_STATION_FEEDS = '[Data Feeds] Select Station Feeds';

export const SelectStationFeeds = createAction(SELECT_STATION_FEEDS, props<{ payload: string[] }>());

// select geofencing feeds
export const SELECT_GEOFENCING_FEEDS = '[Data Feeds] Selected Geofencing Feeds';

export const SelectGeofencingFeeds = createAction(SELECT_GEOFENCING_FEEDS, props<{ payload: string[] }>());

// action types
export type DataFeedAction =
    | typeof LoadDataFeeds
    | typeof LoadDataFeedsSuccess
    | typeof LoadDataFeedsFail
    | typeof RefreshDataFeeds
    | typeof RefreshDataFeedsSuccess
    | typeof RefreshDataFeedsFail
    | typeof RemoveDataFeed
    | typeof SelectVehcileFeeds
    | typeof SelectStationFeeds
    | typeof SelectGeofencingFeeds;
